module.exports = __webpack_public_path__ + "img/cart.a7fc2ff8.svg";